<template>
  <section>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
    />
    <v-card class="p-0" v-if="id_persona">
      <v-card-text>
        <v-layout row wrap justify-center>
          <v-flex xs12 class="text-xs-center blue--text"
            ><b>{{ $moment(fecha_marcado).format("DD/MM/YYYY") }}</b></v-flex
          >
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="l_seguimiento"
              class="elevation-1"
              :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
              :loading="loading"
              item-key="index"
              rows-per-page-text="Filas por pagina"
              :pagination.sync="pagination"
            >
              <template v-slot:headers="props">
                <tr>
                  <th
                    class="text-xs-center"
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : ''
                    ]"
                    id="cabecera_tabla"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small color="white">arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td class="text-xs-center">
                  {{ $moment(props.item._created_at).format("DD/MM/YYYY") }}
                </td>
                <td class="text-xs-center">
                  {{ $moment(props.item._created_at).format("HH:mm:ss") }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.usuario.nombre_usuario }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.cerrado ? "CERRADO" : "ABIERTO" }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.motivo }}
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  components: {},
  mixins: [validate],
  props: ["id_persona", "fecha_marcado"],
  data() {
    return {
      valid: false,
      form: {},
      loading: false,
      url_backend: process.env.API_URL.split("api/")[0],
      l_seguimiento: [],
      // Variables tabla
      pagination: {
        sortBy: ""
      },
      headers: [
        {
          text: "Fecha",
          value: "_created_at",
          align: "center"
        },
        {
          text: "Hora",
          value: "_created_at",
          align: "center"
        },
        {
          text: "Usuario",
          value: "usuario",
          align: "center"
        },
        {
          text: "Acción",
          value: "cerrado",
          align: "center"
        },
        {
          text: "Justificación",
          value: "motivo",
          align: "center"
        }
      ]
    };
  },
  watch: {
    async fecha_marcado(old, new_value) {
      this.l_seguimiento = await this.obtieneSeguimiento(
        this.id_persona,
        this.fecha_marcado
      );
    }
  },
  async created() {
    this.l_seguimiento = await this.obtieneSeguimiento(
      this.id_persona,
      this.fecha_marcado
    );
  },
  async mounted() {},

  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // Metodo para listar el seguimiento
    async obtieneSeguimiento(id_persona, fecha_marcado) {
      this.loading = true;
      try {
        let rpta = await this.$service.graphql({
          query: `
            query{
              seguimientoControlAsistencias(id_persona: ${id_persona},fecha_marcado :"${fecha_marcado}"){
                rows{
                  fecha_marcado
                  cerrado
                  id_persona
                  motivo
                  _user_created
                  _created_at
                }
              }
          }
        `
        });
        let lista_tmp = rpta.seguimientoControlAsistencias.rows;
        for (let index = 0; index < lista_tmp.length; index++) {
          const element = lista_tmp[index];
          let rpta = await this.$service.graphql({
            query: `
            query{
              usuario(id:${element._user_created}){
                nombre_usuario
              }
            }
          `
          });
          element.usuario = rpta.usuario ? rpta.usuario : {};
        }
        this.loading = false;
        return lista_tmp;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
.list-wrapper__dragarea {
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/tipificacion/components/SeguimientoTipificacion.vue